<template>
  <div class="comp-main">
    <div
      v-for="(item, index) in list"
      v-show="!(item.val === 'Quote' && !id)"
      :key="index"
      @click="itemClick(item.val)"
      :class="{ 'nav-item': true, active: item.val === module }"
    >
      {{ item.key }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    module: {
      type: String,
      required: true
    },
    id: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      selfModule: '',
      list: [
        {
          key: '核算单详情',
          val: 'Verify'
        },
        {
          key: '报价单详情',
          val: 'Quote'
        },
        {
          key: '合同详情',
          val: 'Contract'
        }
      ]
    }
  },
  watch: {
    module(val) {
      this.selfModule = val
    }
  },
  methods: {
    itemClick(val) {
      this.selfModule = this.$emit('update:module', val)
    }
  }
}
</script>

<style lang="less" scoped>
.comp-main {
  width: 72px;
  height: 100%;
  background: @colorGrayF;
  .nav-item {
    display: block;
    height: 40px;
    line-height: 40px;
    padding-left: 5px;
    color: @colorBlack;
    text-decoration: none;
    border-left: 2px solid transparent;
    cursor: pointer;
    &.active {
      color: @colorBlue;
      background: @colorShallowBlue;
      border-color: @colorBlue;
    }
  }
}
</style>
